import { Stroke, Style } from "ol/style";

// Lighter resting colours for the sub-sections of a way NOT covered by any
// crosslink relation. CrosslinkCoverageHandler precomputes those sub-sections
// as `crosslinkUncoveredGeoms`; we overlay them on top of the normal colour.
const SD_UNCOVERED_COLOR = "#90ee90"; // lightgreen
const HD_UNCOVERED_COLOR = "#add8e6"; // lightblue
// This way's section that pairs with a crosslink relation whose role overshoots
// the PARTNER member's length (road overshoots → lane segment red, and vice
// versa). A data error, drawn on top in red (CrosslinkCoverageHandler
// precomputes the segments as `crosslinkOutOfBoundsGeoms`).
const OUT_OF_BOUNDS_COLOR = "red";
const LINE_WIDTH = 3;

export function getCrosslinkStyleNormal(feature) {
  return getCrosslinkColorStyle(feature);
}
export function getCrosslinkStyleClick(feature) {
  return getCrosslinkColorStyle(feature, true, false);
}
export function getCrosslinkStyleHover(feature) {
  return getCrosslinkColorStyle(feature, false, true);
}
export function getCrosslinkStyleSDSelected() {
  return getCrosslinkStyleSD(true);
}
export function getCrosslinkStyleSDDeselected(click, hover) {
  return getCrosslinkStyleSD(false, click, hover);
}
export function getCrosslinkStyleHDSelected() {
  return getCrosslinkStyleHD(true);
}
export function getCrosslinkStyleHDDeselected() {
  return getCrosslinkStyleHD(false);
}
export function isSD(feature) {
  return feature.getId().startsWith("6:");
}
function isHDLaneLine(feature) {
  const hdMapKeys = feature.getKeys().filter((key) => key.endsWith("-hdmap"));
  if (hdMapKeys.length === 0) {
    return false;
  }
  return ["lane_center_line", "lane_trajectory_line"].includes(
    feature.get(hdMapKeys[0]),
  );
}
function getCrosslinkColorStyle(feature, click, hover) {
  const crosslinkType = feature.get("type");
  if (crosslinkType === "ORBIS_RELATION") {
    return [];
  }
  const sd = isSD(feature);
  if (!sd && !isHDLaneLine(feature)) {
    return [];
  }
  const styles = sd
    ? getCrosslinkStyleSD(false, click, hover)
    : getCrosslinkStyleHD(false);
  // In the resting state (not hovering/clicking), shade the sub-sections that
  // no crosslink relation covers in a lighter colour, drawn over the base line.
  if (!click && !hover) {
    const uncoveredGeoms = feature.get("crosslinkUncoveredGeoms");
    if (uncoveredGeoms) {
      const lighter = sd ? SD_UNCOVERED_COLOR : HD_UNCOVERED_COLOR;
      uncoveredGeoms.forEach((geometry) => {
        styles.push(
          new Style({
            geometry: geometry,
            stroke: new Stroke({ color: lighter, width: LINE_WIDTH }),
            zIndex: 2,
          }),
        );
      });
    }
  }
  // Partner-overshoot segment in red — always shown (even on hover/click) so
  // the data error stays visible, and on top of everything.
  const outOfBoundsGeoms = feature.get("crosslinkOutOfBoundsGeoms");
  if (outOfBoundsGeoms) {
    outOfBoundsGeoms.forEach((geometry) => {
      styles.push(
        new Style({
          geometry: geometry,
          stroke: new Stroke({
            color: OUT_OF_BOUNDS_COLOR,
            width: LINE_WIDTH + 1,
          }),
          zIndex: 12,
        }),
      );
    });
  }
  return styles;
}

function getCrosslinkStyleSD(selected, click, hover) {
  let color = "green";
  let zIndex = 1;
  if (selected) {
    color = "green";
    zIndex = 10;
  } else if (click) {
    color = "orange";
  } else if (hover) {
    color = "green";
  }
  return [
    new Style({
      stroke: new Stroke({
        color: color,
        width: LINE_WIDTH,
      }),
      zIndex: zIndex,
    }),
  ];
}
function getCrosslinkStyleHD(selected) {
  let color = "blue";
  let zIndex = 1;
  if (selected) {
    color = "red";
    zIndex = 10;
  }
  return [
    new Style({
      stroke: new Stroke({
        color: color,
        width: LINE_WIDTH,
      }),
      zIndex: zIndex,
    }),
  ];
}
